import React, { useEffect, useState } from 'react';
import { Col, Row, Divider } from 'antd';
import EdenredTypo from '@sharedComponent/typography';
import EmployeeService from 'src/services/employee-service';
import { CorporateService } from 'src/services';
import { DotLoader } from 'react-spinners';
import EdenredButtons from '@pages/DesignSystem/button/EdenredButton';
import { images } from 'src/assets/img';
import { useHistory } from 'react-router-dom';
import ImageComponent from '@sharedComponent/image-component';
import { icons } from 'src/assets/icons';
import Edenredmodal from '@pages/DesignSystem/Edenredmodal';
import DatePickers from '@pages/DesignSystem/date-flat-picker';
import generateTransactionStatementPDF from './TransactionStatementPDF';
import generateTransactionExcel from './TransactionExcelDownload';
import { message } from 'antd';
import { getLocalvariable } from '@helpers';
import { APP_VARIABLES } from '@constants/app-constants';
import BlueRadioButton from '@sharedComponent/blue-radio/BlueRadioButton';

const getTransactionType = (typeId) => {
	const typeMap = {
		1: 'Opening Balance',
		2: 'Deposit',
		3: 'Payment',
		4: 'Internal Transfer',
		5: 'Refund',
		6: 'Adjustment',
		7: 'Other',
		8: 'SIF Charges',
		9: 'Bank Charges'
	};
	return typeMap[typeId] || 'Other';
};

const TransactionHistoryPresentational = () => {
	const [isDataLoading, setIsDataLoading] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [fromDate, setFromDate] = useState(null);
	const [toDate, setToDate] = useState(null);
	const [fileType, setFileType] = useState('xls');
	const [isDownloading, setIsDownloading] = useState(false);

	useEffect(() => {
		if (!isModalOpen) {
			setFromDate(null);
			setToDate(null);
		}
	}, [isModalOpen]);

	let history = useHistory();
	const changeNumbertoCurrency = (number) => {
		let amount = number.toLocaleString('az-AE', {
			maximumFractionDigits: 2,
			minimumFractionDigits: 2,
		});
		let splitAmount = amount.toString().split('.');
		let currency = (
			<>
				<EdenredTypo className="integer_part">{splitAmount[0]}</EdenredTypo>
				<EdenredTypo className="decimal_part">.{splitAmount[1]}</EdenredTypo>
			</>
		);
		return currency;
	};

	let employeeApi = new EmployeeService();
	let corporateApi = new CorporateService();

	const [transactionHistory, settransactionHistory] = useState([]);
	let availableBalance = localStorage.getItem('amount') || '0';
	useEffect(() => {
		getTransactionHistory();
	}, []);

	async function getTransactionHistory() {
		setIsDataLoading(true);
		try {
			let response = await employeeApi.getTransactionHistoryApi();
			if (response && response.data) {
				settransactionHistory(response.data || []);
			}
		} catch (err) {
			console.log(err);
		}
		setIsDataLoading(false);
	}

	async function downloadTransactionStatement() {
		setIsDownloading(true);

		const formatDateToISO = (dateString) => {
			if (!dateString) return null;
			const dateParts = dateString.trim().split('/');
			const [day, month, year] = dateParts;
			return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
		};

		const formattedFromDate = formatDateToISO(fromDate);
		const formattedToDate = formatDateToISO(toDate);

		try {
			let response = await corporateApi.downloadTransactionStatement(formattedFromDate, formattedToDate);
			if (response.data.isSuccessful && response.data.data && response.data.data.length > 0) {
				const transactionData = response.data.data;
				const branchName = getLocalvariable(APP_VARIABLES.CORPORATE_NAME);
				const formattedData = transactionData.map((transaction) => {
					return {
						date: new Date(transaction.date).toLocaleDateString('en-GB'),
						branchId: `${transaction.corporateId} | ${branchName}`,
						description: transaction.description,
						type: getTransactionType(transaction.typeId),
						debit: (transaction.debit || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
						credit: (transaction.credit || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
						bankReference: transaction.bankTransactionId || ''
					};
				});
				if (fileType === 'pdf') {
					try {
						const pdfDoc = generateTransactionStatementPDF(formattedData);
						pdfDoc.save(`TransactionStatement_${fromDate}_to_${toDate}.pdf`);
						setIsModalOpen(false);
					} catch (error) {
						message.error('Something went wrong: Error generating PDF.');
					}
				} else if (fileType === 'xls') {
					try {
						const success = generateTransactionExcel(formattedData, fromDate, toDate);
						if (!success) {
							message.error('Something went wrong: Error generating Excel.');
						}
					} catch (error) {
						message.error('Something went wrong: Error generating Excel.');
					}
				}
			}
		} catch (error) {
			message.error('Something went wrong: Error downloading statement.');
		} finally {
			setIsDownloading(false);
			setIsModalOpen(false);
		}
	}

	return (
		<>
			<Col className="transaction_history_presentational">
				{isDataLoading && (
					<Col style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
						<DotLoader size={50} color={'#e91d24'} loading />
					</Col>
				)}
				{!isDataLoading && (
					<Row className="transaction-history-container">
						<div className="title_and_button_wrapper">
							<h1>Transaction History</h1>
							<EdenredButtons
								onClick={() => {
									history.goBack();
								}}
								btnType="secondary"
								leftIcon={<img src={images.leftsarrow} />}
								className="go-back-button">
								Back
							</EdenredButtons>
						</div>
						<Col xl={24} lg={24} md={24} sm={24} xs={24} className="transaction-history-col">
							{/* header */}
							<Row className="transaction-history-header">
								<Col xl={18} lg={18} md={16} xs={12} sm={12}>
									<EdenredTypo>Available Balance</EdenredTypo>
									<EdenredTypo className="aed-amount">
										{changeNumbertoCurrency(Number(availableBalance))}
										<EdenredTypo className="aed"> AED </EdenredTypo>
									</EdenredTypo>
								</Col>
								<Col xl={6} lg={6} md={8} xs={12} sm={12}>
									<EdenredButtons
										btnType="secondary"
										disabled={transactionHistory.length === 0}
										leftIcon={<ImageComponent src={icons.focus_state.payrollDownloadArrow} />}
										onClick={() => {
											setIsModalOpen(true);
										}}>
										Download Statement
									</EdenredButtons>
								</Col>
							</Row>
							{/* table header col */}
							<Row className="transaction-history-table-header">
								<Col xl={6} lg={6} md={6}>
									<EdenredTypo className="column">Date</EdenredTypo>
								</Col>
								<Col xl={12} lg={12} md={12}>
									<EdenredTypo className="column">Description</EdenredTypo>
								</Col>
								<Col xl={6} lg={6} md={6}>
									<EdenredTypo className="column">Amount</EdenredTypo>
								</Col>
							</Row>
							{/* table content */}
							{transactionHistory.length > 0 ? (
								transactionHistory.map((historydetail, index) => {
									return (
										<Row className="transaction-history-table-content">
											<Col lg={24} md={24} xl={24} className="month-header">
												<EdenredTypo>{historydetail.month}</EdenredTypo>
											</Col>
											<Divider />
											{historydetail.transactions.map((transaction_detail, i) => (
												<>
													<Col xl={24} lg={24} md={24} className="content-detail">
														<Row className="transaction_detail_row">
															<Col xl={6} lg={6} md={6}>
																<EdenredTypo className="transaction_date">{transaction_detail.date}</EdenredTypo>
															</Col>
															<Col xl={12} lg={12} md={12}>
																<EdenredTypo className="transaction_detail">
																	{transaction_detail.description}
																</EdenredTypo>
															</Col>
															<Col xl={6} lg={6} md={6}>
																<EdenredTypo
																	className={`transaction_amount${transaction_detail.amount.split('')[0] === '+' ? ' credit' : ''
																		}`}>
																	{changeNumbertoCurrency(transaction_detail.amount)}
																</EdenredTypo>
															</Col>
														</Row>
													</Col>
													<Divider />
												</>
											))}
										</Row>
									);
								})
							) : (
								<div className="transaction-history-table-content" style={{ textAlign: 'center', color: '#ddd', fontWeight: 600 }}>
									No records found
								</div>
							)}

							{/* table content mobile */}
							{transactionHistory.length > 0 ? (
								transactionHistory.map((historydetail, index) => {
									return (
										<Row className="transaction-history-table-mobile">
											<Col lg={24} md={24} xl={24} className="month-header">
												<EdenredTypo>{historydetail.month}</EdenredTypo>
											</Col>
											<Divider />
											{historydetail.transactions.map((transaction_detail, i) => (
												<>
													<Col xs={24} sm={24} className="content-detail">
														<Row className="transaction_detail_section">
															<Col xs={16} sm={16} className="transaction_date_detail_column">
																<EdenredTypo className="transaction_detail">
																	{transaction_detail.description}
																</EdenredTypo>
																<EdenredTypo className="transaction_date">{transaction_detail.date}</EdenredTypo>
															</Col>
															<Col xs={8} sm={8} className="transaction_amount_column">
																<EdenredTypo
																	className={`transaction_amount${transaction_detail.amount.split('')[0] === '+' ? ' credit' : ''
																		}`}>
																	{changeNumbertoCurrency(transaction_detail.amount)}
																</EdenredTypo>
															</Col>
														</Row>
													</Col>
													<Divider />
												</>
											))}
										</Row>
									);
								})
							) : (
								<div className="transaction-history-table-mobile" style={{ textAlign: 'center', color: '#ddd', fontWeight: 600 }}>
									No records found
								</div>
							)}
						</Col>
					</Row>
				)}
				<Edenredmodal
					mainModalClassName='download_statement_modal'
					isOpen={isModalOpen}
					closeModal={() => setIsModalOpen(false)}
					title='Download Statement'
					desc="Enter the dates for which you need the statement"
					onOkayButton='Download'
					onCancelButton='Cancel'
					close={() => setIsModalOpen(false)}
					onOkay={() => downloadTransactionStatement()}
					onOkayDisable={!fromDate || !toDate || isDownloading}
					loading={isDownloading}
					onCancel={() => setIsModalOpen(false)}
				>
					<div>
						<DatePickers
							dateMode="range"
							value={fromDate && toDate ? `${fromDate}to${toDate}` : ''}
							onChange={(dateString) => {
								if (dateString) {
									const [start, end] = dateString.split('to');
									setFromDate(start ? start.trim() : null);
									setToDate(end ? end.trim() : null);
								} else {
									setFromDate(null);
									setToDate(null);
								}
							}}
							rangeDateFromPlaceHolder="From"
							rangeDateToPlaceHolder="To"
						/>
						<div className='download_statement_modal_radio_buttons'>
							<BlueRadioButton
								checked={fileType === 'xls'}
								onChange={() => setFileType('xls')}
								value="xls"
								label="As .xls"
							/>
							<BlueRadioButton
								checked={fileType === 'pdf'}
								onChange={() => setFileType('pdf')}
								value="pdf"
								label="As .pdf"
							/>
						</div>

					</div>
				</Edenredmodal>


			</Col >
		</>
	);
};

export default TransactionHistoryPresentational;
